import { useQuery } from '@tanstack/react-query';

import { getOrgSenderIds } from '../settings.service';
import { GetOrgSenderIdsQueryParams } from '../settings.types';

// Query keys
export const senderIdsKeys = {
  byOrgAndBrand: (orgId: string, brandId?: string) => ['senderIds', 'org', orgId, brandId] as const,
};

// Fetching sender IDs by org
export const useOrgSenderIds = (
  orgId: string,
  queryParams?: GetOrgSenderIdsQueryParams,
  options?: { isEnabled?: boolean }
) => {
  return useQuery({
    enabled: options?.isEnabled !== false,
    queryFn: () => getOrgSenderIds(orgId, queryParams),
    queryKey: senderIdsKeys.byOrgAndBrand(orgId, queryParams?.brandId),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
